import { MListTextPairProps, MListTextPairVariant } from './MListTextPair.types';
import * as Styled from './MListTextPair.styles';
import { ABody } from '../../atoms/ABody';
import { ASubheader } from '../../atoms/ASubheader';
const COMPONENT_NAME = 'm-web-ui-kit-MListTextPair';
const TEST_ID = 'web-ui-kit-MListTextPair';

export function MListTextPair(props: MListTextPairProps) {
  const { variant } = props;

  if (variant === MListTextPairVariant.BodyLeftRight || variant === MListTextPairVariant.BodyLeftLeft) {
    const { aBodyLeft, aBodyRight, ...rest } = props;
    return (
      <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
        <Styled.Column align="left">
          <ABody {...aBodyLeft} />
        </Styled.Column>
        <Styled.Column align={variant === MListTextPairVariant.BodyLeftRight ? 'right' : 'left'}>
          <ABody {...aBodyRight} />
        </Styled.Column>
      </Styled.Wrapper>
    );
  }

  if (variant === MListTextPairVariant.SubheaderLeftRight || variant === MListTextPairVariant.SubheaderLeftLeft) {
    const { aSubheaderLeft, aSubheaderRight, ...rest } = props;
    return (
      <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
        <Styled.Column align="left">
          <ASubheader {...aSubheaderLeft} />
        </Styled.Column>
        <Styled.Column align={variant === MListTextPairVariant.SubheaderLeftRight ? 'right' : 'left'}>
          <ASubheader {...aSubheaderRight} />
        </Styled.Column>
      </Styled.Wrapper>
    );
  }
  return null;
}
